var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnmovable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1.85 1.62 9.75 9.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.854902 0 0 0 0 0.117647 0 0 0 0 0.156863 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.854902 0 0 0 0 0.117647 0 0 0 0 0.156863 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-244 -38)",
    filter: "url(#a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(244.227 38)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.625A4.855 4.855 0 0 1 11.375 6.5 4.855 4.855 0 0 1 6.5 11.375 4.855 4.855 0 0 1 1.625 6.5 4.855 4.855 0 0 1 6.5 1.625ZM5.275 4.194a.5.5 0 0 0-.61-.051.408.408 0 0 0-.109.6l3.125 4.014.044.05a.5.5 0 0 0 .61.05.408.408 0 0 0 .109-.6L5.319 4.243Z",
    fill: "#000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmovable);
export default __webpack_public_path__ + "static/media/unmovable.29adbea5ae1f4ae050b8d036ec322329.svg";
export { ForwardRef as ReactComponent };